/**
 * Web App Badging API — czerwona liczba na ikonie aplikacji.
 *
 * Wsparcie:
 *  - iOS Safari/PWA 16.4+ (po Add to Home Screen, wymaga zgody na powiadomienia)
 *  - Android Chrome PWA
 *  - Chrome/Edge desktop (taskbar / dock)
 *  - Firefox: brak — feature-detect + silent no-op
 *
 * Badge utrzymuje się gdy PWA jest zamknięta — to clue na home-screen ikonie.
 * Foreground (otwarta app) aktualizuje przez `useAppBadgeSync`. Background
 * (zamknięta) aktualizuje SW na podstawie `payload.data.badge` z FCM.
 */

type NavWithBadge = Navigator & {
  setAppBadge?: (count?: number) => Promise<void>;
  clearAppBadge?: () => Promise<void>;
};

export function setAppBadge(count: number): void {
  const nav = navigator as NavWithBadge;
  if (typeof nav.setAppBadge !== "function") return;
  if (count <= 0) {
    void nav.clearAppBadge?.().catch(() => {
      /* silent — brak zgody, brak instalacji, niewspierane */
    });
    return;
  }
  void nav.setAppBadge(count).catch(() => {
    /* silent */
  });
}

export function clearAppBadge(): void {
  const nav = navigator as NavWithBadge;
  if (typeof nav.clearAppBadge !== "function") return;
  void nav.clearAppBadge().catch(() => {
    /* silent */
  });
}
